// POST METHODS
export const POST_PAYMENT_REQUEST = "POST_PAYMENT_REQUEST";
export const POST_PAYMENT_SUCCESS = "POST_PAYMENT_SUCCESS";
export const POST_PAYMENT_FAIL = "POST_PAYMENT_FAIL";

export const POST_WELFARE_BENEFITS_REQUEST = "POST_WELFARE_BENEFITS_REQUEST";
export const POST_WELFARE_BENEFITS_SUCCESS = "POST_WELFARE_BENEFITS_SUCCESS";
export const POST_WELFARE_BENEFITS_FAIL = "POST_WELFARE_BENEFITS_FAIL";

export const POST_IMPORTANT_INFORMATION_REQUEST = "POST_IMPORTANT_INFORMATION_REQUEST";
export const POST_IMPORTANT_INFORMATION_SUCCESS = "POST_IMPORTANT_INFORMATION_SUCCESS";
export const POST_IMPORTANT_INFORMATION_FAIL = "POST_IMPORTANT_INFORMATION_FAIL";

// GET METHODS
export const GET_PAYMENT_REQUEST = "GET_PAYMENT_REQUEST";
export const GET_PAYMENT_SUCCESS = "GET_PAYMENT_SUCCESS";
export const GET_PAYMENT_FAIL = "GET_PAYMENT_FAIL";

export const GET_WELFARE_BENEFITS_REQUEST = "GET_WELFARE_BENEFITS_REQUEST";
export const GET_WELFARE_BENEFITS_SUCCESS = "GET_WELFARE_BENEFITS_SUCCESS";
export const GET_WELFARE_BENEFITS_FAIL = "GET_WELFARE_BENEFITS_FAIL";

export const GET_IMPORTANT_INFORMATION_REQUEST = "GET_IMPORTANT_INFORMATION_REQUEST";
export const GET_IMPORTANT_INFORMATION_SUCCESS = "GET_IMPORTANT_INFORMATION_SUCCESS";
export const GET_IMPORTANT_INFORMATION_FAIL = "GET_IMPORTANT_INFORMATION_FAIL";